<template>
  <div>
    <top-bar/>
    <div class="content ajuda">
      <div class="container text-center" style="padding-top: 48px;padding-bottom: 32px">
        <h5 class="font-weight-bold mb-2">Central de Ajuda</h5>
        <p class="mb-4 mx-auto" style="max-width: 580px">
          Nosso suporte técnico funciona pelo WhatsApp: <b>(16) 99453-3763</b>.<br>
          Você também pode acessar nossa documentação, para visualizar os tutorias de utilização do sistema.
        </p>
        <div class="row justify-content-center">
          <div class="col-md-3 mb-4">
            <router-link to="/ajuda/documentacao" class="card text-decoration-none shadow-sm card-empresa text-dark">
              <div class="card-body py-4">
                <img src="../../assets/imgs/e-book.png" alt="Logo">
                <hr>
                <h6 class="font-weight-bold mb-1">Documentação</h6>
                <div class="small text-muted">Base de conhecimento</div>
                <div class="small text-muted">Tutorias do sistema</div>
              </div>
            </router-link>
          </div>
          <div class="col-md-3 mb-4">
            <a href="https://wa.me/5516994533763?text=Iniciar%20atendimento" target="_blank" class="card text-decoration-none shadow-sm card-empresa text-dark">
              <div class="card-body py-4">
                <img src="../../assets/imgs/fone-de-ouvido.png" alt="Logo">
                <hr>
                <h6 class="font-weight-bold mb-1">Suporte Técnico</h6>
                <div class="small text-muted">Atendimento todos os dias</div>
                <div class="small text-muted">WhatsApp: (16) 99453-3763</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "@/components/commons/TopBar";
  export default {
    name: 'Ajuda',
    components: {TopBar},
  }
</script>

<style scoped>
  .ajuda img {
    width: 100%;
    max-width: 82px;
  }
</style>
